export class CalcEntity {

    "codigo": string
    "assist24hs": string
    "carroReserva": string
    "despesasExtra": string
    "farolRetrovis": string
    "isAcessorios": string
    "isAppInvalidez": string
    "isAppMorte": string
    "isDanosCorporais": string
    "isDanosMateriais": string
    "isDanosMorais": string
    "tipoFranquia": string
    "vidros": string
    "tipoCobertura": string
    "idIntegracaoCfgSeg": string
    "percComissao": string
    "percComissao2": string
    "percComissao3": string
    "percDesconto": string
    "seguradora": string
    "isBlindagem": string
    "isKitGas": string
    "idIntegracaoCfg": string
    "login": string
    "senha": string
    "cotacaoId": string
    "versao": string
    "retorno": boolean
    "ID": string
    "id": string

    constructor(){

        this.codigo = null;
        this.assist24hs = null;
        this.carroReserva = null;
        this.despesasExtra = null;
        this.farolRetrovis = null;
        this.isAcessorios = null;
        this.isAppInvalidez = null;
        this.isAppMorte = null;
        this.isDanosCorporais = null;
        this.isDanosMateriais = null;
        this.isDanosMorais = null;
        this.tipoFranquia = null;
        this.vidros = null;
        this.tipoCobertura = null;
        this.idIntegracaoCfgSeg = null;
        this.percComissao = null;
        this.percComissao2 = null;
        this.percComissao3 = null;
        this.percDesconto = null;
        this.seguradora = null;
        this.isBlindagem = null;
        this.isKitGas = null;
        this.idIntegracaoCfg = null;
        this.login = null;
        this.senha = null;
        this.cotacaoId = null;
        this.versao = null;
        this.retorno = null;
        this.ID = null;
        this.id = null;

    }

}